import React, { Component } from "react";
import {
  View,
  Button,
  Keyboard,
  ScrollView,
  TextInput,
  TouchableOpacity,
  Alert,
} from "react-native";

import Color from "react-native-material-color";
import { connect } from "react-redux";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import Modal from "react-native-modalbox";
import * as actions from "../actions/registerSecondStep";
import * as Commons from "../utils/Commons";
import * as Constants from "../utils/Constants";
import * as Styles from "../utils/Styles";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import Text from "../components/Text";
let styles = {};
class RegisterSecondStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      keyboardVisible: false,
    };
  }

  async componentDidMount() {
    const { user } = this.props;
    try {
      if (user) {
        this.props.setupUserInfo(user);
      } else {
        this.props.setupUserInfo(this.props.route.params.user);
      }
    } catch (err) { }
    const language = await Commons.language();
    const fontFamily = language.startsWith("ar") ? "iran" : "riposte";
    const textAlign = language.startsWith("ar") ? "right" : "left";
    const fontSize = language.startsWith("ar") ? 13 : 15;
    styles = myStyle({ fontFamily, fontSize, textAlign });
    this.props.updateState({ fontFamily, fontSize, textAlign });
  }

  componentWillUnmount() {
    this.props.resetState();
  }




  renderTokenModal() {
    return (
      <Modal
        ref={(el) => (this.otpModal = el)}
        style={[Styles.modal, { marginTop: 250 }]}
        position={"top"}
        animationDuration={250}
        entry="top"
        swipeToClose={false}
        backdropPressToClose={false}
      >
        <Text style={Styles.modalTitle}>{STRINGS.mobile_verification}</Text>
        <TextInput
          ref={(x) => (this.otpTxt = x)}
          style={[
            Styles.modalInput,
            {
              textAlign: "center",
              fontFamily: 'zarid',
              fontSize: this.props.fontSize + 4,
              color: "#6b3529",
            },
          ]}
          autoFocus
          value={this.props.token}
          placeholder={STRINGS.token}
          onChangeText={(token) => this.props.updateState({ token })}
        />
        <View
          style={[
            Styles.modalBtnsView,
            {
              marginTop: 8,
              width: Styles.modal.width - 24,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
            },
          ]}
        >
          <Button
            color="#6b3529"
            title={STRINGS.cancel}
            onPress={() => {
              this.otpModal.close();
            }}
          />
          {Styles.renderSeparator(12)}
          <Button
            color="#6b3529"
            title={STRINGS.register}
            onPress={() => {
              if (
                !this.props.route.params.isUpdate &&
                this.props.token !== this.props.serverToken
              ) {
                alert(STRINGS.wrong_otp_token);
                return;
              }
              this.submit();
            }}
          />
        </View>
      </Modal>
    );
  }

  render() {
    const sharedProps = {
      style: [styles.input, !Styles.isLtr() && { textAlign: "right" }],
      placeholderTextColor: "#6b3529",
      numberOfLines: 1,
      autoCapitalize: "none",
    };
    return (
      <View
        style={{
          alignItems: "center",
          paddingBottom: 16,
          flex: 1,
          backgroundColor: "white",
        }}
      >
        {Commons.loadFonts(this)}
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light
          navigation={this.props.navigation}
          navigateToLogin={() => {
            this.props.navigation.navigate("login", { isGuest: true });
          }}
        />
        {/* {Commons.renderAppBackground()} */}
        <View
          style={[{ alignSelf: "center", flex: 1 }, Styles.subContainerMedium]}
        >
          <ScrollView
            contentContainerStyle={{
              paddingBottom: 80,
              alignSelf: "center",
              justifyContent: "center",
              flex: 1,
            }}
            keyboardShouldPersistTaps={"always"}
          >

            {!this.props.route.params.isUpdate && (<Text style={styles.title}>{STRINGS.registration_step_2}</Text>)}
            {this.props.route.params.isUpdate && (<Text style={styles.title}>EDIT INFORMATION</Text>)}
            <View
              style={{
                flexDirection: "row",
                alignSelf: "center",
                width: "100%",
              }}
            >
              {/* First Name */}
              <View style={[styles.optionView, { flex: 0.5 }]}>
                <TextInput
                  {...sharedProps}
                  defaultValue={this.props.firstName}
                  placeholder={STRINGS.first_name}
                  onChangeText={(text) =>
                    this.props.updateState({ firstName: text })
                  }
                />
              </View>

              {/* Last Name */}
              <View style={[styles.optionView, { marginLeft: 10, flex: 0.5 }]}>
                <TextInput
                  {...sharedProps}
                  defaultValue={this.props.lastName}
                  placeholder={STRINGS.last_name}
                  onChangeText={(text) =>
                    this.props.updateState({ lastName: text })
                  }
                />
              </View>
            </View>
            {/*mobile */}
            <View style={[styles.optionView]}>
              <TextInput
                {...sharedProps}
                keyboardType="number-pad"
                returnKeyType="done"
                placeholder={STRINGS.mobile_number}
                defaultValue={this.getMobile(0)}
                onChangeText={(text) => {
                  const mobile = text;
                  const newMobile = this.getNewMobile(mobile, 0);
                  this.props.updateState({ mobile: newMobile });
                }}
              />
            </View>
            {/* Address + City */}
            <View
              style={{
                flexDirection: "row",
                alignSelf: "center",
                width: "100%",
              }}
            >
              <View style={[styles.optionView, { flex: 0.5 }]}>
                <TextInput
                  {...sharedProps}
                  defaultValue={this.getAddress(false)}
                  placeholder={`${STRINGS.address}`}
                  onChangeText={(text) => {
                    const address = text;
                    const newAddress = this.getNewAddress(address, false);
                    this.props.updateState({ address: newAddress });
                  }}
                />
              </View>
              <View style={[styles.optionView, { flex: 0.5, marginLeft: 10 }]}>
                <TextInput
                  {...sharedProps}
                  defaultValue={`${this.props.city}*`}
                  placeholder={`${STRINGS.city}*`}
                  editable={false}
                  onChangeText={(text) => {
                    this.props.updateState({ city: text });
                  }}
                />
              </View>
            </View>
            <Text
              style={{
                fontFamily: this.props.fontFamily,
                fontSize: this.props.fontSize - 2,
                color: "gray",
                alignSelf: "center",
                marginVertical: 5,
              }}
            >
              {"*"}
              {STRINGS.delivery_only_amman}
            </Text>

            {/* Email */}
            <View style={styles.optionView}>
              <TextInput
                {...sharedProps}
                defaultValue={this.props.email}
                placeholder={STRINGS.email_address}
                onChangeText={(text) =>
                  this.props.updateState({
                    email: text.toLowerCase().replace(/ /g, ""),
                    username: text.toLowerCase().replace(/ /g, ""),
                  })
                }
              />
            </View>

            {/* Username */}
            {/* <View style={styles.optionView}>
              <TextInput
                {...sharedProps}
                defaultValue={this.props.username}
                editable={!this.props.route.params.isUpdate}
                placeholder={STRINGS.username}
                onChangeText={(text) =>
                  this.props.updateState({ username: text })
                }
              />
            </View> */}

            {/* Password */}
            <View style={styles.optionView}>
              <TextInput
                {...sharedProps}
                secureTextEntry={!this.props.showPassword}
                defaultValue={this.props.password}
                placeholder={STRINGS.password}
                onChangeText={(text) =>
                  this.props.updateState({ password: text })
                }
              />
            </View>

            {/* Confirm Password */}
            {/* <View style={styles.optionView}>
              <TextInput
                {...sharedProps}
                secureTextEntry={!this.props.showPassword}
                placeholder={STRINGS.confirm_password}
                placeholderTextColor={"#6b3529"}
                onChangeText={(text) =>
                  this.props.updateState({ confirmPassword: text })
                }
              />
            </View> */}

            {/* Username conditions */}
            {/* <Text
              style={[
                styles.conditionTxt,
                { marginBottom: 12 },
                STRINGS.isArLtrOrEnRtl && { textAlign: "right" },
              ]}
            >
              {STRINGS.username_rules}
            </Text> */}

            {/* Password conditions */}
            {/* <Text
              style={[
                styles.conditionTxt,
                STRINGS.isArLtrOrEnRtl && { textAlign: "right" },
              ]}
            >
              {STRINGS.password_rules}
            </Text> */}
            {/* Bottom Buttons */}
            <TouchableOpacity
              style={[
                Styles.bottomTxtView,
                {
                  backgroundColor: "#6b3529",
                  borderColor: "#6b3529",
                  marginTop: 12,
                  borderWidth: 2,
                  padding: 12,
                  width: "40%",
                  alignSelf: "center",
                },
              ]}
              onPress={async () => {
                if (!this.checkFields()) {
                  return;
                }
                if (this.props.route.params.isUpdate) {
                  this.submit();
                } else {
                  const exists = await this.props.checkIfUserExists(this);
                  if (exists) return;
                  this.props.requestOTP(
                    this,
                    this.props.mobile.split("@@")[0]
                  );
                }
              }}
            >
              <Text
                style={[
                  Styles.bottomBtnText,
                  {
                    fontFamily: this.props.fontFamily,
                    fontSize: this.props.fontSize,
                    fontWeight: "bold",
                  },
                ]}
              >
                {/* {!this.props.route.params.isUpdate
                  ? STRINGS.submit_account
                  : STRINGS.submit_account_update} */}
                {!this.props.route.params.isUpdate && STRINGS.signup}
                {this.props.route.params.isUpdate && ("UPDATE")}
              </Text>
            </TouchableOpacity>

          </ScrollView>
        </View>
        {this.renderTokenModal()}
      </View>
    );
  }

  checkFields = () => {
    const { email, username, password, mobile, firstName, lastName } = this.props;
    // const {
    //   firstName,
    //   lastName,
    //   birthdate,
    //   gender,
    //   mobile,
    //   maritalStatus,
    //   numOfChildren,
    //   userLocation,
    //   address,
    // } = this.props.route.params;
    if (
      email.trim() === "" ||
      username.trim() === "" ||
      password.trim() === "" ||
      mobile.trim() === "" ||
      firstName.trim() === "" ||
      lastName.trim() === ""
    ) {
      Commons.fillAllFields();
      return false;
    }
    if (!this.isEmailValid(email)) {
      Commons.okMsgAlert(STRINGS.invalid_email);
      return false;
    }
    if (!this.isUsernameValid(username) && !this.props.route.params.isUpdate) {
      Commons.okMsgAlert(STRINGS.invalid_username);
      return;
    }
    if (!this.isPasswordValid(password) && !this.props.route.params.isUpdate) {
      Commons.okMsgAlert(STRINGS.invalid_password);
      return false;
    }
    // if (password !== confirmPassword) {
    //   Commons.okMsgAlert(STRINGS.password_do_not_match);
    //   return;
    // }
    return true;
  };
  getNewAddress = (address, isSecond) => {
    let newAddress = "";
    if (isSecond) {
      newAddress = `${this.getAddress(false)}@@${address}`;
    } else {
      newAddress = `${address}@@${this.getAddress(true)}`;
    }
    return newAddress;
  };

  getAddress = (isSecondAddress) => {
    const addresses = this.props.address.split("@@");
    if (isSecondAddress) {
      if (addresses.length > 1) {
        return addresses[1];
      }
      return "";
    }
    return addresses[0];
  };

  getNewMobile = (mobile, pos) => {
    let newMobile = "";
    if (pos === 0) {
      newMobile = `${mobile}@@${this.getMobile(1)}@@${this.getMobile(2)}`;
    } else if (pos === 1) {
      newMobile = `${this.getMobile(0)}@@${mobile}@@${this.getMobile(2)}`;
    } else {
      newMobile = `${this.getMobile(0)}@@${this.getMobile(1)}@@${mobile}`;
    }
    return newMobile;
  };

  getMobile = (pos) => {
    const mobiles = this.props.mobile.split("@@");
    if (pos === 0) {
      return mobiles[0];
    }
    if (pos === 1) {
      if (mobiles.length > 1) {
        return mobiles[1];
      }
      return "";
    }
    if (mobiles.length > 2) {
      return mobiles[2];
    }
    return "";
  };

  submit = async () => {
    if (!this.checkFields()) {
      return;
    }
    const { email, username, password, confirmPassword } = this.props;
    const {
      firstName,
      lastName,
      birthdate,
      gender,
      mobile,
      maritalStatus,
      numOfChildren,
      userLocation,
      address,
    } = this.props;
    console.log(user);
    const user = {
      EMAIL: email,
      USERNAME: username,
      PASSWORD: password,
      BIRTHDATE: birthdate,
      GENDER: gender,
      MOBILE: mobile,
      ADDRESS: address,
      MARITAL_STATUS: maritalStatus,
      NUM_OF_CHILDREN: numOfChildren,
      LOCATION: `,`,
      FIRSTNAME: firstName,
      LASTNAME: lastName,
    };
    this.props.registerUser(this, user, this.props.route.params.isUpdate);
  };

  isUsernameValid = (username) =>
    !username.trim().includes(" ") && username.trim().length >= 4;

  isPasswordValid = (password) => {
    if (password.length < 4) {
      return false;
    }

    return true;
  };

  containsArabic = (strValue) => {
    const arabic = /[\u0600-\u06FF]/;
    return arabic.test(strValue);
  };

  isEmailValid = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };
}

const myStyle = (props) => {
  return {
    container: {
      paddingBottom: 16,
    },
    title: {
      fontFamily: props.fontFamily,
      fontSize: props.fontSize + 5,
      fontWeight: "bold",
      color: "#6b3529",
      alignSelf: "center",
      marginBottom: 30,
    },
    optionView: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 12,
      borderBottomWidth: 1,
      borderBottomColor: "#6b3529",
    },
    labelView: {
      flex: 1,
      backgroundColor: "rgba(255,255,255,0.3)",
    },
    label: {
      fontFamily: props.fontFamily,
      fontSize: props.fontSize,
      color: "#6b3529",
      textAlign: "center",
      padding: 10,
    },
    input: {
      flex: 1.5,
      height: 42,
      backgroundColor: "white",
      paddingLeft: 8,
      fontSize: 18,
      color: "#6b3529",
      fontFamily: "zarid",
    },
    conditionTxt: {
      fontFamily: props.fontFamily,
      fontSize: props.fontSize,
      color: "#6b3529",
      textAlign: "left",
    },
    eyeIcon: {
      position: "absolute",
      right: 0,
      paddingHorizontal: 6,
      backgroundColor: "white",
    },
  };
};

const mapStateToProps = ({ registerSecondStep }) => registerSecondStep;

export default connect(mapStateToProps, actions)(RegisterSecondStep);
